import moment from 'moment';

export default {
  methods: {
    manageDate(params) {
      const { date = null, format = null } = params;

      return moment(date).locale('pl').format(format);
    },
  },
};



// WEBPACK FOOTER //
// ./app/javascript/packs/shared/mixins/manage_date.js